import { render, staticRenderFns } from "./Authenticating.vue?vue&type=template&id=5a2c9040&"
import script from "./Authenticating.vue?vue&type=script&lang=ts&"
export * from "./Authenticating.vue?vue&type=script&lang=ts&"
import style0 from "./Authenticating.vue?vue&type=style&index=0&id=5a2c9040&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports